<template>
  <div>
    <navigationFab />
    <v-img
      src="https://images.unsplash.com/photo-1507676385008-e7fb562d11f8?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1049&q=80"
      gradient="#FFFFFF00, #000000"
      max-height="25vh"
    >
      <v-row>
        <v-col class="mt-16" align="center">
          <span class="primary--text text-md-h2 text-h3 font-weight-bold"
            >Edit Current Favourites Playlist</span
          >
        </v-col>
      </v-row>
    </v-img>
    <div v-if="!loading" class="px-8 pb-16">
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6" class="d-flex justify-center">
          <span class="font-weight-bold text-h6"
            >Select the tracks you want to remove from your Current Favourites
            Playlist</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6">
          <v-card
            v-for="editTrack in editTracks"
            :key="editTrack.id"
            color="background"
          >
            <v-row>
              <v-col cols="1" class="d-flex justify-center">
                <v-checkbox
                  @change="manageSelected(editTrack)"
                  :value="editTrack"
                  :disabled="checkBoxDisabled"
                ></v-checkbox>
              </v-col>
              <v-col cols="3" sm="1" class="d-flex justify-center">
                <v-hover v-slot="{ hover }" close-delay="100">
                  <trackCover
                    :cover="editTrack.cover"
                    :sample="editTrack.sample"
                    :hover="hover"
                    :size="70"
                  />
                </v-hover>
              </v-col>
              <v-col cols="8" md="10">
                <v-row>
                  <v-col class="pb-0 font-weight-bold primary--text">
                    {{ editTrack.name }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-0 text-subtitle-2 ">
                    {{ editTrack.artist }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6" align="center">
          <v-btn color="primary" @click="removeTracks"
            >Remove {{ selectedTracks.length }} Track<span
              v-if="selectedTracks.length === 0 || selectedTracks.length > 1"
              >s</span
            ></v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div v-else class="px-8 centered">
      <v-row>
        <v-col cols="3"></v-col>
        <v-col cols="12" md="6" align="center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import navigationFab from "../components/general/navigationFab";
import trackCover from "../components/editCurrentFavs/editTrackCover";
export default {
  name: "EditCurrentFavs",
  title: "Edit Current Favourites Playlist",
  components: {
    navigationFab,
    trackCover,
  },
  data() {
    return {
      editTracks: [],
      loading: true,
      selectedTracks: [],
      checkBoxDisabled: false,
    };
  },
  methods: {
    removeTracks: async function() {
      this.checkBoxDisabled = true;
      if (this.selectedTracks.length > 0) {
        let payload = {
          authToken: this.$cookies.get("authToken"),
          tracks: this.selectedTracks,
          curPlaylist: this.$globalState.listify.curPlaylist,
        };
        let response = await fetch(this.$apiUrl + "/task/removeTracks", {
          method: "POST",
          body: JSON.stringify(payload),
        });
        let responseData = await response.json();
        if (responseData.state) {
          let Notify = {
            duration: 4000,
            type: "success",
            headline: "Edit Current Favourites Playlist",
            message: responseData.msg,
          };
          this.$globalState.addNotification(Notify);
          this.$globalState.listifyInfo.curRemAmount = this.selectedTracks.length;
          this.$router.push("/listified");
        } else {
          let Notify = {
            duration: 4000,
            type: "error",
            headline: "Edit Current Favourites Playlist",
            message: responseData.msg,
          };
          this.$globalState.addNotification(Notify);
          this.$router.push("/");
        }
      } else {
        this.$globalState.listifyInfo.curRemAmount = this.selectedTracks.length;
        this.$router.push("/listified");
      }
    },
    manageSelected: function(track) {
      //chech if array already contains track
      if (this.selectedTracks.includes(track.uri)) {
        //includes track -> remove it from array
        this.selectedTracks = this.selectedTracks.filter(
          (item) => item != track.uri
        );
      } else {
        //isn't included -> add track to array
        this.selectedTracks.push(track.uri);
      }
    },
    getCovers: async function() {
      for (let i = 0; i < this.editTracks.length; i++) {
        let element = this.editTracks[i];
        let authToken = this.$cookies.get("authToken");
        let response = await fetch(
          "https://api.spotify.com/v1/tracks/" + element.id,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + authToken.access_token,
            },
          }
        );
        let responseData = await response.json();
        this.editTracks[i].cover = responseData.album.images[0].url;
      }
    },
  },
  async mounted() {
    this.editTracks = this.$globalState.listify.editTracks;
    await this.getCovers();
    this.loading = false;
  },
};
</script>

<style scoped>
.v-centered {
  display: grid;
  place-items: center end;
}

.remaining-height {
  height: 70vh;
}
.centered {
  display: grid;
  place-items: center stretch;
  height: 70vh;
}
</style>
